import styled from "styled-components";
import colors from "../../designSystem/colors";
import sizing from "../../designSystem/sizing";
import { EditableTableTextStyleProps } from "./types";

export const ButtonWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
`;

export const EditableTableTextContainer = styled.div<EditableTableTextStyleProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: ${sizing.RADIUS.MEDIUM};
  flex: 1;
  max-width: ${props => props.maxWidth || "100%"};
  background-color: inherit;
  min-width: ${props => props.minWidth || "100px"};
  & > * {
    font-weight: 500;
  }

  border: ${({ isEditing, isError, $alwaysBorder }) =>
    isEditing
      ? `
    1px solid ${
      isError ? colors.UI.BORDER.DANGER : colors.UI.BORDER.STANDARD
    };  
    `
      : $alwaysBorder
      ? `1px solid ${colors.UI.BORDER.STANDARD};`
      : "none"};
`;

export const TextWrapper = styled.div<{ textColor?: string }>`
  padding-left: 0;
  flex-grow: 1;
  display: flex;
  align-items: center;
  min-width: 0;
  color: ${({ textColor }) => textColor || "inherit"};
  position: relative;

  &:hover::after {
    content: attr(data-fulltext);
    position: absolute;
    top: 100%;
    left: 0;
    background: rgba(26, 32, 44, 0.9);
    color: white;
    padding: 6px 8px;
    border-radius: 4px;
    white-space: nowrap;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    z-index: 10;
    pointer-events: none;
  }
`;
